<template>
  <div>
    <div class="cover" ref="coverRef" v-show="visible" @click="onCloseCover" :style="'z-index: ' + zIndex + ';'">
      <div :class="{
        'modal-box': true,
        show: show,
      }" :style="{
        width: width + 'px',
        top: top + 'px',
        left: left + 'px',
      }" ref="dragBoxRef" @click.stop="() => false">
        <div class="modal-title" ref="dragAbleRef">
          <div class="title">{{ title }}</div>
          <div class="close" @click="onClose">
            <CloseOutlined style="font-size: 16px" />
          </div>
        </div>
        <div class="modal-body" :style="{
          height: height > 0 ? height + 'px' : 'auto',
        }">
          <slot></slot>
        </div>
        <div class="modal-footer" v-if="footer">
          <slot name="footer">
            <div class="btns">
              <a-button style="margin-right: 15px" @click="onClose">取消</a-button>
              <a-button type="primary" @click="onOk" :loading="loading" :disabled="disabled">
                {{ okText }}
              </a-button>

            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts" setup>
import { addEvent, prEvent, removeEvent } from '@/utils';
import { CloseOutlined } from '@ant-design/icons-vue'
import { nextTick, onMounted, ref, watch } from 'vue';
// eslint-disable-next-line no-undef
const props = defineProps({
  visible: Boolean,
  onlyBody: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  title: String,
  okText: {
    type: String,
    default: '确定'
  },
  offsetTop: Number,
  closeAble: {
    type: Boolean,
    default: true
  },
  footer: {
    type: Boolean,
    default: true
  },
  width: {
    type: Number,
    default: 400
  },
  height: {
    type: Number,
    default: 0
  },
  zIndex: {
    type: Number,
    default: 99996
  }
})

const top = ref(0)
const left = ref(0)
const show = ref(false)

// eslint-disable-next-line no-undef
const emit = defineEmits(['close', 'ok'])
const onClose = () => {
  emit('close')
}

const onOk = () => {
  emit('ok')
}

const dragBoxRef = ref()
const dragAbleRef = ref()
const setModalStyle = () => {
  const w = props.width
  const tW = document.body.clientWidth
  const tH = document.body.clientHeight
  const h = dragBoxRef.value.clientHeight
  left.value = (tW - w) / 2
  const jstop = props.offsetTop ? props.offsetTop : (tH - h) / 2
  show.value = true
  top.value = jstop > 0 ? jstop : 0
  console.log(top.value)
}

const onDrag = () => {
  const drag = dragAbleRef.value
  const body = dragBoxRef.value
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addEvent(drag, 'mousedown', function (ev: any) {
    var oEvent = prEvent(ev)
    var oParent = body.parentNode
    var disX = oEvent?.clientX - body.offsetLeft
    var disY = oEvent?.clientY - body.offsetTop
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var startMove = function (ev: any) {
      if (oParent.setCapture) {
        oParent.setCapture()
      }
      var oEvent = ev || window.event
      var L = oEvent.clientX - disX
      var T = oEvent.clientY - disY
      body.style.left = L + 'px'
      body.style.top = T + 'px'

      oParent.onselectstart = function () {
        return false
      }
    }
    var endMove = function () {
      if (oParent.releaseCapture) {
        oParent.releaseCapture()
      }
      oParent.onselectstart = null

      removeEvent(oParent, 'mousemove', startMove)
      removeEvent(oParent, 'mouseup', endMove)
    }
    addEvent(oParent, 'mousemove', startMove)
    addEvent(oParent, 'mouseup', endMove)
    return false
  })
}

onMounted(() => {
  nextTick(() => {
    onDrag()
  })
})

watch(() => props.visible, (val) => {
  if (val) {
    setTimeout(() => {
      setModalStyle()
    }, 10)
  }
})
</script>

<style lang="less" scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  transition: all 0.5s ease;
}

.modal-box {
  background: #fff;
  position: absolute;
  opacity: 0;
  overflow: hidden;
  transition: opacity 0.5s ease;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  max-height: 716px;

  .modal-title {
    cursor: move;
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title,
    .close {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      word-wrap: break-word;
    }

    .close {
      cursor: pointer;
    }
  }

  .modal-body {
    padding: 15px 20px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
    max-height: 600px;
  }

  .modal-footer {
    border-top: 1px solid #f0f0f0;
    padding: 15px 20px;

    .btns {
      display: flex;
      justify-content: flex-end;
    }
  }

  &.show {
    opacity: 1;
  }
}
</style>